import RequestUrls from '@Constants/RequestUrlsConstants';
import MessageBroker from '@Services/MessageBroker';

const cachedRequests = {
  plannerMenuItems: null,
};

export function getMenuSynthesisItems() {
  if (cachedRequests.plannerMenuItems) {
    return cachedRequests.plannerMenuItems;
  }
  cachedRequests.plannerMenuItems = MessageBroker.send(RequestUrls.plannerMenuItems);
  return cachedRequests.plannerMenuItems;
}

export function getNewHitsetByStructure(structure) {
  const payload = { structure };

  return MessageBroker.send(RequestUrls.plannerNewHitsetByStructure, payload);
}

export function getNewHitsetBySimilar(structure, databaseId, similarity, substanceId) {
  const payload = {
    structure,
    databaseId,
    options: [
      {
        name: 'similarity',
        value: similarity,
      },
    ],
    ...(substanceId && { substanceId }),
  };

  return MessageBroker.send(RequestUrls.plannerNewHitsetBySimilar, payload);
}
